import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import { createNotification } from "../../../shared/store/notifications";
import _cookies from "../../../shared/utils/_cookies";

export async function restrictSocialMediaPost({ postId }) {
  const body = new FormData();
  body.append(
    "dados",
    `[${JSON.stringify({
      postagemid: postId,
      gestorid: _cookies.getItem("auth").user?.profile?.isGestor?.ID,
    })}]`
  );
  const res = await axios.middleware.post(
    "/Social.asmx/RestringirPostagem",
    body
  );
  return res;
}

export const useRestrictPost = ({ config, postId } = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => restrictSocialMediaPost({ postId }),

    onSuccess: () => {
      createNotification({
        type: "success",
        message: "Post restringido com sucesso",
      });

      queryClient.invalidateQueries(["socialMediaFeed"]);
    },
  });
};
